import type { RetryOptions } from '../../types';
import { getShouldRetryBasedOnMaxRetries } from './getShouldRetryBasedOnMaxRetries';

export type GetShouldRetryParams = {
  retryOptions: RetryOptions;
  numberOfFailedAttempts: number;
  response: Response;
};

export const getShouldRetry = ({
  retryOptions,
  numberOfFailedAttempts,
  response,
}: GetShouldRetryParams): boolean => {
  const fn = retryOptions.getShouldRetry ?? getShouldRetryBasedOnMaxRetries;

  return fn({
    maxRetries: retryOptions.maxRetries,
    numberOfFailedAttempts,
    response,
  });
};
